import { useEffect, useState } from "react";
import { startingPointsProvider } from "../providers/startingPointsProvider";
import { getAuthenticatedServerClient } from "../api/server.api";

interface GeoCoordinates {
  lat: number;
  lng: number;
}

const _cache = new Map<string, GeoCoordinates>();

export function useGeoCoordinates(startingPointId: string | null | undefined): GeoCoordinates | undefined {
  const startingPoint = startingPointId ? startingPointsProvider.getOneFromCache(startingPointId) : undefined;
  const geoCoordinates =
    startingPoint?.postalAddress.geoCoordinates ?? (startingPointId ? _cache.get(startingPointId) : undefined);
  const [fetched, setFetched] = useState<boolean>(!!geoCoordinates);
  useEffect(() => {
    if (startingPoint && !fetched) {
      void (async () => {
        try {
          const serverClient = await getAuthenticatedServerClient();
          const geoCoordinates = await serverClient.getGeoCoordinates({
            queries: {
              street: startingPoint.postalAddress.street,
              postalCode: startingPoint.postalAddress.postalCode,
              city: startingPoint.postalAddress.city,
            },
          });
          _cache.set(startingPoint.id, geoCoordinates);
          setFetched(true);
        } catch (error) {
          console.error("Failed to get geocoordinates", error);
        }
      })();
    }
  }, [startingPoint, fetched]);
  return geoCoordinates;
}
